import {
  FlagUpdatesVariantDetails,
  createFlagUpdatesChangeExtension,
} from '@spotify/plugin-confidence-flags-react';

export const VARIANT_CHANGE_EXTENSION = createFlagUpdatesChangeExtension({
  id: 'variant-change',
  predicate: ({ change }) =>
    change.fieldType === 'confidence.flags.admin.v1.Flag.Variant',
  render: ({ change }) => (
    <FlagUpdatesVariantDetails
      oldVariant={change.oldValue}
      newVariant={change.newValue}
    />
  ),
});
